export default __webpack_public_path__ + "static/media/scan_delete.a943e031.svg";